import { useNavigate } from 'react-router-dom'

import { IsAdmin } from 'app/IsAdmin'
import { IsNotAdmin } from 'app/IsNotAdmin'
import DownloadIcon from 'assets/icons/download.svg'
import { Button } from 'components/Button'
import { StepStrip } from 'pages/BrandAssessment/StepStrip'

export const BrandListMainHeader = () => {
  const navigate = useNavigate()
  const handleDownload = () => {
    const link = document.createElement('a')
    link.href =
      'https://facade-api.dev.mos.coke.com/v3/download-file/bucket/facade-bucketstandarbackendstack-facade-development/bva%2F2026%2FBVAToolkit.pptx'
    link.download = 'sample.pdf'
    link.click()
  }
  const handleCheckProcess = () => {
    navigate('/', { state: { scrollTo: 'bva-process-detail' } })
  }
  return (
    <div className="w-full mt-[40px] px-4 md:px-10 lg:px-20 pt-6 md:pt-10 lg:pt-16 pb-4 md:pb-6 lg:pb-10 header-brandlist-layout inline-flex flex-col justify-start items-start gap-2 overflow-hidden">
      <div className="w-full mx-auto">
        <div className="w-full self-stretch flex flex-col md:flex-row justify-between items-start md:items-end gap-6">
          <div className="flex-1 inline-flex flex-col justify-start items-start gap-4">
            <div className="self-stretch inline-flex justify-start items-start gap-4">
              <div className="justify-start headline-xxl leading-[60px]">BVA Frameworks</div>
            </div>

            <IsAdmin>
              <div className="w-full max-w-[800px] justify-start body-m leading-6">
                This is the starting point of your BVA process, where you have full control to start, stop, and jump
                back whenever needed. Go deeper by downloading the Toolkit, or get a quick run-through, all at your own
                pace.
              </div>
            </IsAdmin>
            <IsNotAdmin>
              <div className="w-full max-w-[800px] justify-start body-m leading-6">
                Dive into every BVA across TCCC brands. Here you can explore all available BVAs, past and present,
                review key information, and get a clear overview whenever you need it.
              </div>
            </IsNotAdmin>
          </div>
          <div className="inline-flex flex-col justify-center items-center gap-2">
            <Button
              text="Check BVA Process"
              color="white"
              border={false}
              className="btn-big btn--secondary !w-[202px]"
              onClick={handleCheckProcess}
            />
            <Button
              text="Download Toolkit"
              color="white"
              border={false}
              className="btn-big btn--secondary !w-[202px]"
              onClick={handleDownload}
              icon={<img src={DownloadIcon} alt="Download" className="ml-2" width="16" height="16" />}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

interface ProcessMainHeaderProps {
  activeIndex: number
}

export const ProcessMainHeader = ({ activeIndex }: ProcessMainHeaderProps) => {
  return (
    <div className="w-full header-brandlist-layout flex flex-col items-start gap-8 px-4 md:px-10 lg:px-20 pb-4 md:pb-6 lg:pb-10 overflow-hidden">
      <div className="w-[1280px] mx-auto flex flex-col items-start gap-8">
        <p className="process-header-watermark w-full">THE BVA PROCESS</p>
        <StepStrip activeIndex={activeIndex} />
      </div>
    </div>
  )
}
